import axios from 'axios'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'

class ShipmentsItemStatusChangerService {
    // Mark a batch of shipment items as not received
    async markNotReceived(
        destinationLaboratoryId: number,
        shipmentItemIds: EntityIdentifiersRequest
    ): Promise<void> {
        const response = await axios.put<void>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItems/markAsNotReceived`,
            shipmentItemIds)
        return response.data
    }

    // Mark a batch of shipment items as received
    async markReceived(
        destinationLaboratoryId: number,
        shipmentItemIds: EntityIdentifiersRequest
    ): Promise<void> {
        const response = await axios.put<void>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItems/markAsReceived`,
            shipmentItemIds)
        return response.data
    }
}

export const shipmentsItemStatusChangerService = new ShipmentsItemStatusChangerService()
